<template>
  <div>
    <table>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Subject</th>
        <th>Message</th>
      </tr>
      <tr v-for="(value, index) in items" :key="index">
        <td>{{ value.name }}</td>
        <td>{{ value.email }}</td>
        <td>{{ value.phone }}</td>
        <td>{{ value.subject }}</td>
        <td>{{ value.message }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import firebase from "firebase/app"
import "firebase/database"
export default {
  data: () => ({
    items: []
  }),
  mounted() {
    firebase
      .database()
      .ref("root/")
      .orderByKey()
      .once("value", val => {
        val.forEach(child => {
          let item = child.val();
          this.items.push(item);
        });
      });
  }
};
</script>

<style scoped>
table {
  margin: 5rem 0;
  font-family: arial, sans-serif;
  border-collapse: separate;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  border-radius: 0.4rem;
}

tr:nth-child(even) {
  background-color: #ebebeb;
}
</style>
